import { makeStyles } from '@material-ui/core'
import theme from 'theme'

const styles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.white,
    width: '100%',
    minWidth: 0,
    overflow: 'hidden',
    padding: theme.spacing(2),
    cursor: (props) => (props.clickable ? 'pointer' : 'default'),
    border: (props) =>
      props.clickable && props.selected
        ? `2px solid ${props.backgroundColor}`
        : 'none',
    transition: 'border-color 150ms ease',
  },
  colorBar: {
    width: 6,
    alignSelf: 'stretch',
    flexShrink: 0,
    backgroundColor: (props) => props.backgroundColor,
    margin: theme.spacing(-2, 0, -2, -2),
  },
  iconContainer: {
    width: 48,
    height: 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: (props) => props.backgroundColor,
    borderRadius: 8,
    flexShrink: 0,
  },
  icon: {
    color: theme.palette.white,
    lineHeight: 0,
  },
  content: {
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
    width: '100%',
  },
  value: {
    fontSize: 24,
    fontWeight: 600,
    color: (props) => props.backgroundColor,
    lineHeight: 1.2,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
    display: 'block',
  },
  label: {
    fontSize: 12,
    fontWeight: 500,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    marginTop: 4,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
    display: 'block',
  },
  subLabel: {
    fontSize: 11,
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
    display: 'block',
  },
}))

export default styles
